module.exports = __webpack_public_path__ + "static/Carousel2-bf660ad076648acc8e735a978252757f.jpg";